<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiDrag } from "@mdi/js";
export default {
  name: "MdiAccount",
  data() {
    return {
      svgPath: mdiDrag,
    };
  },
};
</script>
